import { PostChannel } from '@/__generated__/graphql';
import { ChannelPage } from '@/components/compound-components/settings/integrations-tab/connect-button';
import { FC, ReactNode, createContext, useContext, useState } from 'react';

export interface SettingsContext {
  isIntegrationLoading?: boolean;
  setIntegrationLoading?: (value?: boolean) => void;
  integrationShowPageLinking?: boolean;
  setIntegrationShowPageLinking?: (value?: boolean) => void;
  integrationPageList?: ChannelPage[];
  setIntegrationPageList?: (values?: ChannelPage[]) => void;
  integrationPagesCheckedToLink?: ChannelPage[];
  setIntegrationPagesCheckedToLink?: (values?: ChannelPage[]) => void;
  integrationPlatformChannels?: PostChannel[];
  setIntegrationPlatformChannels?: (values?: PostChannel[]) => void;
}

interface AccountProviderProps {
  children: ReactNode;
}

const defaultState: SettingsContext = {};

const SettingsContext = createContext<SettingsContext>(defaultState);

export const useSettingsConntext = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettingsContext must be used within a UserProvider');
  }
  return context;
};

export const SettingsProvider: FC<AccountProviderProps> = ({ children }) => {
  const [isIntegrationLoading, setIntegrationLoadingInternal] = useState<
    boolean | undefined
  >(false);

  const setIntegrationLoading = (mode?: boolean) => {
    setIntegrationLoadingInternal(mode);
  };

  const [integrationPageList, setIntegrationPageListInternal] = useState<
    ChannelPage[] | undefined
  >([]);

  const setIntegrationPageList = (values?: ChannelPage[]) => {
    setIntegrationPageListInternal(values);
  };

  const [
    integrationPagesCheckedToLink,
    setIntegrationPagesCheckedToLinkInternal,
  ] = useState<ChannelPage[] | undefined>([]);

  const setIntegrationPagesCheckedToLink = (values?: ChannelPage[]) => {
    setIntegrationPagesCheckedToLinkInternal(values);
  };

  const [integrationPlatformChannels, setIntegrationPlatformChannelsInternal] =
    useState<PostChannel[] | undefined>([]);

  const setIntegrationPlatformChannels = (values?: PostChannel[]) => {
    setIntegrationPlatformChannelsInternal(values);
  };

  const [integrationShowPageLinking, setIntegrationShowPageLinkingInternal] =
    useState<boolean | undefined>(false);

  const setIntegrationShowPageLinking = (value?: boolean) => {
    setIntegrationShowPageLinkingInternal(value);
  };

  return (
    <SettingsContext.Provider
      value={{
        isIntegrationLoading,
        setIntegrationLoading,
        integrationPageList,
        setIntegrationPageList,
        integrationPagesCheckedToLink,
        setIntegrationPagesCheckedToLink,
        integrationPlatformChannels,
        setIntegrationPlatformChannels,
        integrationShowPageLinking,
        setIntegrationShowPageLinking,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};
